export const ROUTES = {
  HOME: "/",
  AUTH: "/auth",
  DASHBOARD: "/dashboard",
  PRICING: "/pricing",
  TEMPLATES: "/templates",
  ABOUT: "/about",
  CONTACT: "/contact",
  PRIVACY_POLICY: "/privacy-policy",
  TERMS_OF_USE: "/terms-of-use",
  SHIPPING_DELIVERY: "/shipping-delivery",
  CANCELLATIONS_REFUNDS: "/cancellations-refunds",
} as const;
